
export default {
  strava_bike_hour_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/5",
  strava_bike_day_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/6", //strava dvir, pakeistas
  strava_bike_month_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/8", //strava dviratininkai, pakeistas
  strava_bike_year_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/9", // pakeistas
  strava_bike_week_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/7", // pakeistas

  waze_jams:
    "https://services1.arcgis.com/usA3lHW20rGU6glp/arcgis/rest/services/waze_jams/FeatureServer/1", // waze duomenys

  strava_pedest_hour_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/0",
  strava_pedest_day_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/1", //strava pestieji diena, pakeistas
  strava_pedest_month_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/3", //strava pestieji menesis, pakeistas
  strava_pedest_year_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/4", // pakeistas
  strava_pedest_week_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/2", // pakeistas

  op_car_hour_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/9", // pakeistas
  op_car_day_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/6", // pakeistas
  op_car_week_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/27", // pakeistas
  op_car_month_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/15", // pakeistas
  op_car_year_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/13", // pakeistas

  op_bike_hour_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/2", // pakeistas
  op_bike_day_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/1", // pakeistas
  op_bike_week_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/5", // pakeistas
  op_bike_month_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/4", // pakeistas
  op_bike_year_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/3", // pakeistas

  op_pedest_hour_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/18", // pakeistas
  op_pedest_day_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/17", // pakeistas
  op_pedest_week_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/21", // pakeistas
  op_pedest_month_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/20", // pakeistas
  op_pedest_year_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/19", // pakeistas

  op_bus_hour_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/23", // pakeistas
  op_bus_day_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/22", // pakeistas
  op_bus_week_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/26", // pakeistas
  op_bus_month_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/25", // pakeistas
  op_bus_year_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/24", // pakeistas

  op_car_agg_day_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/8", // pakeistas
  op_car_agg_week_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/12", // pakeistas
  op_car_agg_month_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/11", // pakeistas
  op_car_agg_year_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/10", // pakeistas

  op_sum_day_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/7", // pakeistas
  op_sum_week_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/28", // pakeistas
  op_sum_month_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/16", // pakeistas
  op_sum_year_url:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/14", // pakeistas

  operator:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/0", // pakeistas
  operatorData:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/32", // pakeistas

  operatorAvailableDates:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/30", // pakeistas
  operatorBikeData:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/31", // pakeistas
  operatorPedestrianData:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/33", // pakeistas
  operatorBusData:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/34", // pakeistas


  extent:
    "https://opencity.idvilnius.lt/server/rest/services/Hosted/Extentas_linija/FeatureServer/23", // pakeistas
  hexGrid:
    "https://opencity.idvilnius.lt/server/rest/services/Hosted/Hexagon250/FeatureServer/24", // pakeistas
  nightTable:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/36", // pakeistas
  dayTable:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/37", // pakeistas
  infoTable:
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/35", // pakeistas
  infoTableHours:
    "https://opencity.idvilnius.lt/server/rest/services/TESTAVIMAI/Judumas_zones/MapServer/1",
  meteo:
    "https://opencity.idvilnius.lt/atviras/rest/services/Aplinka/Meteo_duomenys/MapServer/1", // pakeistas
  // Automobilio operatoriu duomenys
  juduData:
    "https://arcgis.sisp.lt/arcgis/rest/services/VIS/Traffic_Volumes/MapServer/0",

  searchService:
    "https://opencity.idvilnius.lt/server/rest/services/Lokatoriai/Gatviu_lokatorius_JUDUMUI/GeocodeServer",

  uniquePeople:
    "https://opencity.idvilnius.lt/server/rest/services/TESTAVIMAI/Judumas_dev/MapServer/1",

  VTReach: 
    "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/38"
};
